import classNames from "classnames"
import { Icon } from "../Icon"
import { MenuBarProps } from "./types"

export const MenuBar = ({ editor, disabled }: MenuBarProps) => {
  if (!editor) {
    return null
  }

  const getButtonClassName = (isActive: boolean): string => {
    return classNames("rounded-sm h-6 w-6 flex justify-center items-center", {
      "bg-gray-200": isActive,
      "hover:bg-gray-100": !isActive,
    })
  }

  // TODO: i18n
  // TODO: replace buttons with Button + icon when the Button component is ready
  return (
    <div
      className={classNames("flex flex-wrap gap-3 border-b p-2 pt-2", {
        "text-gray-400": disabled,
      })}
    >
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("bold"))}
      >
        <span className="sr-only">Bold</span>
        <Icon aria-hidden name="TextBolder" size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("italic"))}
      >
        <span className="sr-only">Italic</span>
        <Icon aria-hidden name="TextItalic" size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("underline"))}
      >
        <span className="sr-only">Underline</span>
        <Icon name="TextUnderline" aria-hidden size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("heading", { level: 1 }))}
      >
        <span className="sr-only">Heading one</span>
        <Icon name="TextHOne" aria-hidden size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("heading", { level: 2 }))}
      >
        <span className="sr-only">Heading two</span>
        <Icon name="TextHTwo" aria-hidden size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("heading", { level: 3 }))}
      >
        <span className="sr-only">Heading three</span>
        <Icon name="TextHThree" aria-hidden size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("heading", { level: 4 }))}
      >
        <span className="sr-only">Heading four</span>
        <Icon name="TextHFour" aria-hidden size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("bulletList"))}
      >
        <span className="sr-only">Bullet list</span>
        <Icon name="ListBullets" aria-hidden size="xs" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        disabled={disabled}
        className={getButtonClassName(editor.isActive("orderedList"))}
      >
        <span className="sr-only">Numbered list</span>
        <Icon name="ListNumbers" aria-hidden size="xs" />
      </button>
      <button type="button" disabled={disabled} onClick={() => editor.chain().focus().undo().run()}>
        <span className="sr-only">Undo</span>
        <Icon name="ArrowUUpLeft" aria-hidden size="xs" />
      </button>
      <button type="button" disabled={disabled} onClick={() => editor.chain().focus().redo().run()}>
        <span className="sr-only">Redo</span>
        <Icon name="ArrowUUpRight" aria-hidden size="xs" />
      </button>
    </div>
  )
}
